module.exports = __webpack_public_path__ + "img/processing-05.96de0785.svg";